import * as React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import gql from 'graphql-tag';
import { Query, MutationFunc } from 'react-apollo';
import { Col, Divider, Row, Spin, Alert, notification } from 'antd';
import { Title } from '../../components/Layout/components';
import VouchersForm from './VouchersForm';

interface IVouchersGenerateRandomProps extends RouteComponentProps<{
  eshop: string,
  groupId: string;
}> {
  generateRandomVouchers: MutationFunc;
}

interface IVouchersGenerateRandomtate {
  redirectBack: boolean;
}

class VouchersGenerateRandom extends React.Component<IVouchersGenerateRandomProps, IVouchersGenerateRandomtate> {

  public constructor(props: IVouchersGenerateRandomProps) {
    super(props);

    this.state = {
      redirectBack: false,
    };

    this.onSave = this.onSave.bind(this);
    this.backToList = this.backToList.bind(this);
  }

  public render() {
    const { eshop, groupId } = this.props.match.params;

    if (this.state.redirectBack) {
      return (<Redirect to={`/${eshop}/application/vouchers/${groupId}`} />);
    }

    return (
      <Query
        query={GetVoucherGroup}
        variables={{
          voucherGroupId: this.props.match.params.groupId
        }}
      >
        {({ data: { loading, error, data } }) => {
          return (
            <>
              <Row>
                <Col span={24}>
                  <Title>Generate random vouchers</Title>
                  <Divider />
                  <div>
                    {loading === true
                      && <Spin />}
                    {loading === false && data && data.voucherGroup &&
                      <>
                        <VouchersForm
                          onSave={(vouchersData: any) => this.onSave(data.voucherGroup.id, vouchersData)}
                          onCancel={this.backToList}
                        />
                      </>}
                    {error &&
                      <Alert
                        type={'error'}
                        message={'Voucher group not found'}
                      />}
                  </div>

                </Col>
              </Row>
            </>
          );
        }}
      </Query>
    );
  }

  private backToList() {
    this.setState({
      redirectBack: true,
    });
  }

  private onSave(voucherGroupId: string, data: any) {
    if (voucherGroupId) {
      this.props.generateRandomVouchers({
        variables: {
          data: {
            voucherGroupId,
            ...data,
            count: parseInt(data.count),
            usageLimit: parseInt(data.usageLimit),
          }
        }
      }).then((result) => {
        notification['success']({
          message: 'Success',
          description: `Vouchers has been generated`
        });
        this.backToList();

      }).catch((error) => {
        notification['success']({
          message: 'danger',
          description: `Vouchers generated failed!`
        });

      });
    }
  }
}

const GetVoucherGroup = gql`
  query voucherGroup($voucherGroupId: String!) {
    voucherGroup(voucherGroupId: $voucherGroupId) {
      id
      active
      title
      source
      type
      amount
    }
  }
`;

export default VouchersGenerateRandom;


// WEBPACK FOOTER //
// ./src/scenes/VouchersGenerateRandom/VouchersGenerateRandom.tsx